export function getListIndentLevel(path) {
  var count = 1;
  path.forEach(function (node) {
    if (node.type.name === 'bulletList' || node.type.name === 'orderedList') {
      count++;
    }
  });
  return count;
}